import type { DoorViewSide } from '../surfaces/doorViewSide';

export type DoorRenderComponent = 'frame' | 'slab' | 'threshold' | 'cill';

/**
 * A component whose internal face is not the shared geometry mirrored.
 * Register here when that face gets its own artwork or construction.
 */
export interface ComponentViewOverrideSpec {
  hasInternalGeometry: boolean;
  /** Paint the override in unflipped overall coordinates. */
  bypassSharedTransform: boolean;
}

const INTERNAL_GEOMETRY_OVERRIDES: Partial<Record<DoorRenderComponent, ComponentViewOverrideSpec>> =
  {
    // No component has a distinct internal construction yet.
  };

export function getComponentViewOverride(
  component: DoorRenderComponent
): ComponentViewOverrideSpec | null {
  return INTERNAL_GEOMETRY_OVERRIDES[component] ?? null;
}

/** Shared flipped geometry unless this component has registered an internal override. */
export function usesSharedViewGeometry(
  component: DoorRenderComponent,
  viewSide: DoorViewSide
): boolean {
  if (viewSide === 'external') return true;
  return !getComponentViewOverride(component)?.hasInternalGeometry;
}
